import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';

function AdminWelderFields({ formData, updateField }) {
    // Helper functions for multi-select fields
    const toggleArrayField = (field, item) => {
        const currentArray = formData[field] || [];
        const updated = currentArray.includes(item)
            ? currentArray.filter(i => i !== item)
            : [...currentArray, item];
        updateField(field, updated);
    };

    // Industry options
    const industries = [
        "Oil & Gas", "Shipyard", "Construction",
        "Petrochemical", "Manufacturing", "Power Plant"
    ];

    // Welding Process options
    const weldingProcesses = [
        "MIG (GMAW)", "TIG (GTAW)", "FCAW", "SMAW (ARC)"
    ];

    // Welding Positions
    const weldingPositions = ["1G", "2G", "3G", "4G", "5G", "6G"];

    // Material Experience
    const materialExperiences = [
        "Carbon Steel", "Stainless Steel", "Aluminum", "Duplex", "Alloy Steel", "All Materials"
    ];

    // Thickness Worked On
    const thicknesses = [
        "1–3 mm (Sheet metal)", "3–6 mm", "6–12 mm", "12–25 mm", "25 mm and above", "All Thicknesses"
    ];

    // Technical Knowledge
    const technicalKnowledgeOptions = [
        "Read welding drawings", "Read isometric drawings",
        "Fit-up knowledge", "Grinding & gas cutting",
        "Use of measuring tools",
        "Working as per WPS"
    ];

    // Certificate Types
    const certificateTypes = ["6G", "ASME", "AWS", "ISO"];

    return (
        <>
            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Industry Details *</h4>
                <Row className="g-3 mb-3">
                    {industries.map((industry, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.industry === industry ? 'selected-button' : ''}`}
                                onClick={() => {
                                    updateField('industry', industry);
                                    updateField('other_industry', ''); // clear other if standard selected
                                }}
                            >
                                {industry}
                            </Button>
                        </Col>
                    ))}
                    <Col xs={12}>
                        <Form.Control
                            type="text"
                            placeholder="Other (Type here)"
                            className="jobtype-btn w-100 h-100 text-center"
                            style={{
                                backgroundColor: formData.industry === 'Other' ? '#0d6efd' : '#f8f9fa',
                                color: formData.industry === 'Other' ? 'white' : 'black',
                                border: 'none'
                            }}
                            value={formData.other_industry || ''}
                            onChange={(e) => {
                                updateField('industry', 'Other');
                                updateField('other_industry', e.target.value);
                            }}
                            onClick={() => {
                                if (formData.industry !== 'Other') {
                                    updateField('industry', 'Other');
                                }
                            }}
                        />
                    </Col>
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Welding Skills & Positions</h4>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Welding Process:</h6>
                <Row className="g-3 mb-4">
                    {weldingProcesses.map((process, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.welding_process?.includes(process) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('welding_process', process)}
                            >
                                {process}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Welding Positions:</h6>
                <Row className="g-3 mb-4">
                    {weldingPositions.map((pos, idx) => (
                        <Col xs={4} sm={4} md={2} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.welding_positions?.includes(pos) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('welding_positions', pos)}
                            >
                                {pos}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Material Experience:</h6>
                <Row className="g-3 mb-4">
                    {materialExperiences.map((mat, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.material_experience?.includes(mat) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('material_experience', mat)}
                            >
                                {mat}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Thickness Worked On:</h6>
                <Row className="g-3 mb-4">
                    {thicknesses.map((thick, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.thickness_worked_on?.includes(thick) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('thickness_worked_on', thick)}
                            >
                                {thick}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Technical Knowledge</h4>
                <Row className="g-3">
                    {technicalKnowledgeOptions.map((knowledge, idx) => (
                        <Col xs={12} sm={6} md={4} key={idx} className="d-flex align-items-stretch">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 h-100 ${formData.welder_technical_knowledge?.includes(knowledge) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('welder_technical_knowledge', knowledge)}
                            >
                                {knowledge}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Certification Details</h4>

                <Row className="g-4">
                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>ITI / Trade Certificate:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.iti_trade_certificate === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => updateField('iti_trade_certificate', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.iti_trade_certificate === 'No' ? 'selected-button' : ''}`}
                                onClick={() => updateField('iti_trade_certificate', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Welding Certificate:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.welding_certificate === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => updateField('welding_certificate', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.welding_certificate === 'No' ? 'selected-button' : ''}`}
                                onClick={() => updateField('welding_certificate', 'No')}
                            >
                                No
                            </Button>
                        </div>

                        {formData.welding_certificate === 'Yes' && (
                            <div className="mt-3">
                                <Form.Group>
                                    <Form.Label style={{ color: "black", fontWeight: 'bold' }}>Certificate Type:</Form.Label>
                                    <Row className="g-2">
                                        {certificateTypes.map((type, idx) => (
                                            <Col xs={3} key={idx}>
                                                <Button
                                                    variant="light"
                                                    className={`language-btn jobtype-btn w-100 ${formData.welding_certificate_type === type ? 'selected-button' : ''}`}
                                                    onClick={() => updateField('welding_certificate_type', type)}
                                                    style={{ padding: '8px 4px', fontSize: '0.9rem' }}
                                                >
                                                    {type}
                                                </Button>
                                            </Col>
                                        ))}
                                    </Row>
                                </Form.Group>
                            </div>
                        )}
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Have you passed any trade test before?</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.passed_trade_test === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => updateField('passed_trade_test', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.passed_trade_test === 'No' ? 'selected-button' : ''}`}
                                onClick={() => updateField('passed_trade_test', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Ready for trade test?</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.ready_for_trade_test === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => updateField('ready_for_trade_test', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.ready_for_trade_test === 'No' ? 'selected-button' : ''}`}
                                onClick={() => updateField('ready_for_trade_test', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default AdminWelderFields;
